var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDocumentMultipleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "file-document-multiple-outline",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M16 0H8a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6l-6-6Zm4 18H8V2h7v5h5v11ZM4 4v18h16v2H4a2 2 0 0 1-2-2V4h2Zm6 6v2h8v-2h-8Zm0 4v2h5v-2h-5Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocumentMultipleOutline);
export default __webpack_public_path__ + "static/media/file-document-multiple-outline.991ae75c0e635e4c520c2a7fd4a94fb0.svg";
export { ForwardRef as ReactComponent };